<template>
  <b-container class="form-signin">
    <b-row>
      <b-col>
        <h1 class="title-pages text-center pt-1 pb-1">Alterar senha</h1>
      </b-col>
    </b-row>
    <request-code
      v-if="page == 'request-code'"
      :timeoutMessage="timeoutMessage"
      @recover-with-code="page = 'recover-with-code'"
      @requested="evOnCodeRequested"
    />
    <recover-with-code
      v-if="page == 'recover-with-code'"
      :timeoutMessage="timeoutMessage"
      @request-code="page = 'request-code'"
      @token-received="evOnTokenReceived"
    />
    <recover-with-token
      v-if="page == 'recover-with-token'"
      :timeoutMessage="timeoutMessage"
      :email="email"
      :token="token"
      @canceled="evOnTokenCanceled"
      @recovered="evOnPasswordRecovered"
    />
    <errors-messages :errors="errors" />
  </b-container>
</template>

<script>
import api from "../services/api";
import RequestCode from "../templates/NewPassword/RequestCode.vue";
import RecoverWithCode from "../templates/NewPassword/RecoverWithCode.vue";
import RecoverWithToken from "../templates/NewPassword/RecoverWithToken.vue";
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

export default {
  name: "NewPassword",
  components: {
    RequestCode,
    RecoverWithToken,
    RecoverWithCode,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      loading: false,

      page: "request-code",

      timeoutHandler: {},
      timeout: 0,
      timeoutMessage: "",

      token: "",
      email: "",
    };
  },
  created() {
    this.usingToken();
  },
  methods: {
    async usingToken() {
      this.token = this.$router.history.current.params.token;
      if (this.token) await this.proceedWithToken();
    },

    async proceedWithToken() {
      try {
        this.loading = true;

        let params = { token: this.token };
        let response = await api.get("/rest-home/user/new-password", {
          params,
        });
        let { error, errors, email } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.email = email;
          this.page = "recover-with-token";
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async evOnCodeRequested() {
      this.timeout = 10;
      this.timeoutMessage = `Um código foi enviado em seu e-mail. Aguarde ${this.timeout} segundos para ser redirecionado.`;

      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Um código foi enviado em seu e-mail. Aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.page = "recover-with-code";
        }
      }, 1000);
    },

    async evOnTokenReceived(email, token) {
      this.timeout = 5;
      this.timeoutMessage = `Código validado, aguarde ${this.timeout} segundos para ser redirecionado.`;

      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Código validado, aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.email = email;
          this.token = token;
          this.page = "recover-with-token";
        }
      }, 1000);
    },

    async evOnTokenCanceled() {
      this.timeout = 5;
      this.timeoutMessage = `Token cancelado. Aguarde ${this.timeout} segundos para ser redirecionado.`;

      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Token cancelado. Aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.$router.push({ name: "sign-in" });
        }
      }, 1000);
    },

    async evOnPasswordRecovered() {
      this.timeout = 5;
      this.timeoutMessage = `Senha atualizada. Aguarde ${this.timeout} segundos para ser redirecionado.`;

      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Senha atualizada. Aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.$router.push({ name: "sign-in" });
        }
      }, 1000);
    },
  },
};
</script>

<style></style>
